/**
 * Centralized API Configuration
 * 
 * This file contains all API-related configuration.
 * Update the backend URL here to change it across the entire application.
 */

export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://blocks-backend.vercel.app';

